export const isAdminRoute = (pathname: string) => pathname === '/admin' || pathname.startsWith('/manage-') || pathname.startsWith('/admin/') || pathname === '/books';

export const shouldRedirectAdminAccess = (pathname: string): boolean => {
  if (!isAdminRoute(pathname)) {
    return false;
  }

  // Schedule management routes are intentionally left accessible so users can
  // continue creating/editing schedules instead of being bounced back to analytics.
  if (pathname === '/manage-schedule' || pathname.startsWith('/manage-schedule/')) {
    return false;
  }

  const excludedPaths = new Set([
    '/manage-organization-memberships',
    '/manage-organization-members-and-roles',
    '/manage-organization-membership-roles',
    '/manage-organization-requests',
    '/manage-platform-user-roles',
  ]);

  return !excludedPaths.has(pathname);
};
